import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ReturnUrlService } from '../services/return-url.service';
import { map, take } from 'rxjs/operators';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const returnUrlService = inject(ReturnUrlService);
  if (
    !state.url.startsWith('/login') &&
    !state.url.startsWith('/verify-user') &&
    state.url !== '/'
  ) {
    returnUrlService.setReturnUrl(state.url);
  }

  return authService.authState$.pipe(
    take(1),
    map(authState => {
      if (authState.isAuthenticated) {
        const storedReturnUrl = returnUrlService.getReturnUrl();
        if (storedReturnUrl && storedReturnUrl !== state.url) {
          router.navigateByUrl(storedReturnUrl);
          returnUrlService.clearReturnUrl();
          return false;
        }
        return true;
      }
      router.navigate(['/login'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    })
  );
};
